export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            accounts: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        accounts(state) {
            return state.accounts.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setFeesAccount(state, accounts) {
            state.accounts = accounts
        },
    },

    actions: {
        async getFeesAccounts(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-fees-accounts`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setFeesAccount', res.data.accounts);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveFeesAccount(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-fees-account';
            } else {
                url = 'add-fees-account';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getFeesAccounts');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteFeesAccount(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-fees-account/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getFeesAccounts');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
